import { create } from "zustand";

const useSyncProgressStore = create((set) => ({
  percent: "0%",
  productCategoryPercentage: "0",
  productPercentage: "0",
  promotionPercentage: "0",
  setProgress: (updates) => set((state) => ({ ...state, ...updates })),
  resetProgress: () =>
    set({
      percent: "0%",
      productCategoryPercentage: "0",
      productPercentage: "0",
      promotionPercentage: "0",
    }),
}));

export default useSyncProgressStore;
